<template>
  <div>
    <v-card class="card--shadow">
      <v-card-title class="purple accent-4">
        <div class="subtitle-1 white--text text-uppercase">
          Enroll Info Form
        </div>
      </v-card-title>
      <v-card-text>
        <form-require-noti />
        <!-- OUTSIDE TOWNSHIP SECTION -->
        <v-row>
          <v-col lg="6">
            <label>Outside Township <require-sign /></label>
            <v-select
              v-model="patient.outside_tsp"
              :items="outTwnOpt"
              :error="$v.patient.outside_tsp.$error"
              item-text="text"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col v-if="patient.outside_tsp == 2" lg="6">
            <label>OutSide Township Name</label>

            <v-select
              :items="outside_townships"
              v-model="patient.outside_tsp_name"
              item-text="name"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- TRANSFER IN section -->
    <v-card class="card--shadow">
      <v-card-text>
        <v-row>
          <v-col lg="6">
            <label>Transfer In <require-sign /></label>
            <v-select
              :items="transferInOpt"
              v-model="patient.t_in"
              :error="$v.patient.t_in.$error"
              item-text="text"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col v-if="patient.t_in == 2" lg="6">
            <div>
              <div>
                <label>Transfer In Date</label>
                <date-picker
                  @clearDate="patient.t_in_date = null"
                  :date="patient.t_in_date"
                  v-model="patient.t_in_date"
                />
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="patient.t_in == 2">
          <v-col lg="6">
            <label>Transfer In Area</label>
            <v-select
              :items="typeOfTFIn"
              v-model="patient.t_in_type"
              item-text="text"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>

          <v-col lg="6" v-if="patient.t_in_type == 1">
            <label>Transfer In Township</label>
            <v-select
              :items="townships"
              v-model="patient.t_in_township_id"
              item-text="name"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col lg="6" v-if="patient.t_in_type == 2">
            <label>Transfer In Name</label>
            <v-text-field
              v-model.trim="patient.t_in_township_name"
              type="text"
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- DRTB REGIMENT SECTION -->
    <v-card class="card--shadow">
      <v-card-text>
        <v-row>
          <v-col lg="4">
            <label>DRTB Reg No <require-sign /></label>
            <v-text-field
              v-model.trim="patient.mdrtb_reg_no"
              :error="$v.patient.mdrtb_reg_no.$error"
              hide-details
              type="number"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col lg="4">
            <label>DRTB Reg Year <require-sign /></label>
            <v-text-field
              v-model.trim="patient.mdrtb_reg_year"
              :error="$v.patient.mdrtb_reg_year.$error"
              hide-details
              type="number"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col lg="4">
            <label>Mono-Poly<require-sign /></label>
            <v-select
              v-model="patient.mdrtb_monopoly"
              :items="monopoly"
              :error="$v.patient.mdrtb_monopoly.$error"
              item-text="text"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col
            lg="4"
            v-if="admin.township"
            v-show="admin.township.initial == 2"
          >
            <label>DRTB Reg Initial</label>

            <v-select
              :items="mdrTbRegInitialOpt"
              v-model="patient.mdrtb_reg_initial"
              item-text="text"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- TYPE OF PATIENT -->
    <v-card class="card--shadow">
      <v-card-text>
        <v-row>
          <v-col lg="6">
            <label>Type Of Patient <require-sign /></label>
            <v-select
              :items="typeOfPatientOpt"
              v-model="patient.type_of_patient"
              :error="$v.patient.type_of_patient.$error"
              hide-details
              item-text="text"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col lg="6">
            <label>Type of TB <require-sign /></label>
            <v-select
              :items="typeOfTBOpt"
              v-model="patient.type_of_tb"
              :error="$v.patient.type_of_tb.$error"
              hide-details
              item-text="text"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col v-if="patient.type_of_patient === 6" lg="6">
            <label>Subtype for Rx after DRTB Rx</label>
            <v-select
              :items="subTypeRxOpt"
              v-model="coumputeSubTypeRxId"
              hide-details
              item-text="text"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col v-if="patient.type_of_patient === 7" lg="6">
            <label>Subtype for Others</label>
            <v-select
              :items="subTypeOtherOpt"
              v-model="coumputeSubTypeOtherId"
              hide-details
              item-text="text"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- LPA SECTION -->
    <v-card class="card--shadow">
      <v-card-text>
        <h3>LPA Result</h3>
        <v-row>
          <v-col v-for="d in drugs" lg="3" :key="d.text">
            <label>{{ d.text }}</label>
            <v-select
              :items="[{ text: 'Resistant' }, { text: 'Susceptible' }]"
              v-model="patient[d.field]"
              item-text="text"
              item-value="text"
              dense
              outlined
              :disabled="!!patient.lpa_result_contaminated"
            ></v-select>
          </v-col>
          <v-col lg="2">
            <label>Contaminated</label>
            <v-checkbox
              v-model="patient.lpa_result_contaminated"
              value="contaminated"
            ></v-checkbox>
          </v-col>

          <v-col lg="4">
            <label>LPA Date</label>
            <date-picker
              @clearDate="patient.lpa_date = null"
              :date="patient.lpa_date"
              v-model="patient.lpa_date"
            />
          </v-col>
          <v-col lg="3">
            <label>LPA code</label>
            <v-text-field
              v-model.trim="patient.lpa_code"
              type="text"
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="card--shadow">
      <v-card-text>
        <h3>X-pert MTB/XDR Result</h3>
        <v-row>
          <v-col lg="3">
            <label>X-pert MTB/XDR code</label>
            <v-text-field
              v-model.trim="patient.xpert_mtb_code"
              type="text"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col lg="4">
            <label>MTB</label>
            <v-select
              :items="[
                { text: 'MTB detected' },
                { text: 'MTB not detected' },
                { text: 'Invalid/Error' },
              ]"
              v-model="patient.xpert_mtb"
              item-text="text"
              item-value="text"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col v-for="d in xpertDrugs" lg="4" :key="d.text">
            <label>{{ d.text }}</label>
            <v-select
              :items="[
                { text: 'Resistance not detected' },
                { text: 'Resistance detected' },
                { text: ' Low resistance detected' },
                { text: ' Low resistance detected' },
                { text: 'MTB(+) & Resistance indeterminate' },
              ]"
              v-model="patient[d.field]"
              item-text="text"
              item-value="text"
              dense
              outlined
            ></v-select>
          </v-col>

          <v-col lg="4">
            <label>X-pert MTB/XDR Date</label>
            <date-picker
              @clearDate="patient.xpert_mtb_date = null"
              :date="patient.xpert_mtb_date"
              v-model="patient.xpert_mtb_date"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Culture -->
    <v-card class="card--shadow">
      <v-card-text>
        <v-row>
          <v-col lg="6">
            <label>Culture Date</label>
            <date-picker
              @clearDate="patient.culture_date = null"
              :date="patient.culture_date"
              v-model="patient.culture_date"
            />
          </v-col>
          <v-col lg="6">
            <label>Culture Result</label>
            <v-select
              :items="cultureResultOpt"
              v-model="patient.culture_result"
              item-text="text"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col lg="3">
            <label>Culture code</label>
            <v-text-field
              v-model.trim="patient.culture_code"
              type="text"
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- CXR -->
    <v-card class="card--shadow">
      <v-card-text>
        <v-row>
          <v-col lg="6">
            <label>Cxr Date</label>
            <date-picker
              @clearDate="patient.cxr_date = null"
              :date="patient.cxr_date"
              v-model="patient.cxr_date"
            />
          </v-col>
          <v-col lg="6">
            <label>CXR Result</label>
            <v-select
              :items="cxrResultOpt"
              v-model="patient.cxr_result"
              hide-details
              item-text="text"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- COMORBID DEASE SECTION -->
    <v-card class="card--shadow">
      <v-card-text>
        <v-row>
          <v-col lg="12">
            <label>Comorbid Disease <require-sign /></label>
            <v-select
              multiple
              :items="comorbidDieaseOpt"
              v-model="patient.comorbid_diseases"
              :error="$v.patient.comorbid_diseases.$error"
              hide-details
              chips
              item-text="text"
              item-value="comorbid_dieases_id"
              dense
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col lg="6" v-if="patient.comorbid_diseases.includes('6')">
            <label>Other</label>
            <v-text-field
              v-model.trim="patient.comorbid_diseases_other"
              type="text"
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- TREATEMENT SECTION -->
    <v-card class="card--shadow">
      <v-card-text>
        <v-row>
          <v-col lg="6">
            <label>Treatment Start Date </label>
            <date-picker
              @clearDate="patient.treatment_startdate = null"
              :date="patient.treatment_startdate"
              v-model="patient.treatment_startdate"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  <!-- SUPPORT SECTION -->
  <v-card class="card--shadow">
      <v-card-text>
        <v-row>
          <v-col lg="6">
            <label>Support Start Date </label>
            <date-picker
              @clearDate="patient.support_startdate = null"
              :date="patient.support_startdate"
              v-model="patient.support_startdate"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- HIV SECTION -->
    <v-card class="card--shadow">
      <v-card-text>
        <v-row>
          <v-col lg="6">
            <label>HIV Test <require-sign /></label>
            <v-select
              :items="hivStatusOpt"
              v-model="patient.hiv_status"
              :error="$v.patient.hiv_status.$error"
              hide-details
              item-text="text"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col v-if="patient.hiv_status == 2" lg="6">
            <div class="d-flex flex-column">
              <div>
                <label>HIV Date</label>
                <date-picker
                  @clearDate="patient.hiv_date = null"
                  :date="patient.hiv_date"
                  v-model="patient.hiv_date"
                />
              </div>
              <div>
                <label>HIV Result</label>
                <v-select
                  :items="hivResultOpt"
                  v-model="patient.hiv_result"
                  item-text="text"
                  item-value="id"
                  dense
                  outlined
                ></v-select>
              </div>
              <div v-if="patient.hiv_result == 1">
                <label>ART RX</label>
                <v-select
                  :items="artRxOpt"
                  v-model="patient.art_rx"
                  item-text="text"
                  item-value="id"
                  dense
                  outlined
                ></v-select>
              </div>
              <div v-if="patient.hiv_result == 1 && patient.art_rx == 2">
                <label>ART Date</label>
                <date-picker
                  @clearDate="patient.art_rx_date = null"
                  :date="patient.art_rx_date"
                  v-model="patient.art_rx_date"
                />
              </div>
              <div v-if="patient.hiv_result == 1">
                <label>CPT RX</label>
                <v-select
                  :items="cptRxOpt"
                  v-model="patient.cpt_rx"
                  item-text="text"
                  item-value="id"
                  dense
                  outlined
                ></v-select>
              </div>
              <div v-if="patient.hiv_result == 1 && patient.cpt_rx == 2">
                <label>CPT Date</label>
                <date-picker
                  @clearDate="patient.cpt_rx_date = null"
                  :date="patient.cpt_rx_date"
                  v-model="patient.cpt_rx_date"
                />
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- SUPPORT REMARK SECTION -->
    <v-card class="card--shadow">
      <v-card-text>
        <v-row>
          <v-col lg="12">
            <label>Remark</label>
            <v-text-field
              placeholder="remark..."
              v-model.trim="patient.support_remark"
              filled
              dense
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pb-5">
        <v-spacer />
        <v-btn
          :loading="loading"
          @click.prevent="updateEnrollInfo"
          class="form-btn"
        >
          <v-icon left>mdi-chevron-right-circle-outline</v-icon>Update
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import { ValidationMixin } from "../../../mixins/ValidationMixin";
import { mapState, mapActions } from "vuex";
import FormRequireNoti from "@/components/notification/FormRequireNoti.vue";
import RequireSign from "@/components/notification/RequireSign.vue";
import DatePicker from "@/components/common/DatePicker.vue";
import FormValidation from "./services/FormValidation";

export default {
  mixins: [ValidationMixin],
  components: {
    FormRequireNoti,
    RequireSign,
    DatePicker,
  },
  props: {
    patient: {
      type: Object,
      default: () => {
        return {
          outside_tsp: null,
          outside_tsp_name: null,

          t_in: null,
          t_in_date: null,
          t_in_type: null,
          t_in_township_id: null,
          t_in_township_name: null,

          lpa_result_h: null,
          lpa_result_r: null,
          lpa_result_e: null,
          lpa_result_s: null,
          lpa_result_amk: null,
          lpa_result_km: null,
          lpa_result_cm: null,
          lpa_result_fq: null,
          lpa_result_contaminated: null,
          lpa_date: null,
          lpa_code: null,

          mdrtb_reg_no: null,
          mdrtb_reg_year: null,
          mdrtb_monopoly:1,
          mdrtb_regiment: null,
          mdrtb_reg_initial: null,

          xpert_mtb: null,
          xpert_mtb_code: null,
          xpert_mtb_date: null,
          xpert_mtb_h: null,
          xpert_mtb_am: null,
          xpert_mtb_km: null,
          xpert_mtb_cm: null,
          xpert_mtb_fq: null,
          xpert_mtb_eth: null,

          type_of_patient: null,
          type_of_tb: null,
          subtype_patient_other: null,
          subtype_patient_rx: null,

          comorbid_diseases: [],

          treatment_startdate: null,
          support_startdate: null,
          comorbid_diseases_other: null,

          hiv_status: null,
          hiv_date: null,
          hiv_result: null,

          art_rx: null,
          art_rx_date: null,
          cpt_rx: null,
          cpt_rx_date: null,

          culture_date: null,
          culture_result: null,
          culture_code: null,

          cxr_date: null,
          cxr_result: null,

          support_remark: null,
        };
      },
    },
  },
  validations: {
    patient: {
      outside_tsp: { required },
      t_in: { required },
      mdrtb_reg_no: { required, maxLength: maxLength(3) },
      mdrtb_reg_year: { required, maxLength: maxLength(2) },
      mdrtb_monopoly:{required},
      type_of_patient: { required },
      type_of_tb: { required },
      comorbid_diseases: { required },
      // treatment_startdate: { required },
      hiv_status: { required },
    },
  },
  data: () => ({
    formErrors: new FormValidation(),

    reg_no_digit_error: "",
    reg_year_digit_error: "",
    drugs: [
      { text: "H", field: "lpa_result_h" },
      { text: "R", field: "lpa_result_r" },
      { text: "E", field: "lpa_result_e" },
      { text: "S", field: "lpa_result_s" },
      { text: "Amk", field: "lpa_result_amk" },
      { text: "Km", field: "lpa_result_km" },
      { text: "Cm", field: "lpa_result_cm" },
      { text: "FQ", field: "lpa_result_fq" },
    ],
    xpertDrugs: [
      { text: "H", field: "xpert_mtb_h" },
      { text: "Am", field: "xpert_mtb_am" },
      { text: "Km", field: "xpert_mtb_km" },
      { text: "Cm", field: "xpert_mtb_cm" },
      { text: "FQ", field: "xpert_mtb_fq" },
      { text: "Eth", field: "xpert_mtb_eth" },
    ],
  }),
  computed: {
    ...mapState("Admin", ["admin"]),
    ...mapState("InfoData", [
      "mdrTbRegInitialOpt",
      "hivStatusOpt",
      "hivResultOpt",
      "cxrResultOpt",
      "cultureResultOpt",
      "cptRxOpt",
      "cptRxOpt",
      "transferInOpt",
      "artRxOpt",
      "outTwnOpt",
      "monopoly",
      "typeOfTFIn",
      "lpaResistantOpt",
      "lpaSusceptibleOpt",
      "lpaResultOpt",
      "comorbidDieaseOpt",
      "mdrTbRegs",
      "typeOfPatientOpt",
      "subTypeRxOpt",
      "subTypeOtherOpt",
      "typeOfTBOpt",
      "outside_townships",
    ]),
    ...mapState("Loading", ["loading"]),
    ...mapState("Township", ["townships"]),
    coumputeSubTypeRxId: {
      get() {
        return Number(this.patient.subtype_patient_rx);
      },
      set(val) {
        this.patient.subtype_patient_rx = Number(val);
      },
    },
    coumputeSubTypeOtherId: {
      get() {
        return Number(this.patient.subtype_patient_other);
      },
      set(val) {
        this.patient.subtype_patient_other = Number(val);
      },
    },
  },
  methods: {
    ...mapActions("InfoData", ["getTownships", "getOutsideTownships"]),
    ...mapActions("Township", ["getAllTownships"]),
    updateEnrollInfo() {
      //when form submit, used validation mixin function to validate $v object
      this.checkToastValidationMsg(this.$v.patient);
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let data = {
          id: this.$route.params.patientId,

          outside_tsp: this.patient.outside_tsp,
          outside_tsp_name: this.patient.outside_tsp_name,
          
          lpa_result: this.patient.lpa_result,
          lpa_result_h: this.patient.lpa_result_h,
          lpa_result_r: this.patient.lpa_result_r,
          lpa_result_s: this.patient.lpa_result_s,
          lpa_result_e: this.patient.lpa_result_e,
          lpa_result_amk: this.patient.lpa_result_amk,
          lpa_result_cm: this.patient.lpa_result_cm,
          lpa_result_km: this.patient.lpa_result_km,
          lpa_result_fq: this.patient.lpa_result_fq,
          lpa_result_contaminated: this.patient.lpa_result_contaminated,
          lpa_date: this.patient.lpa_date,
          lpa_code: this.patient.lpa_code,

          xpert_mtb: this.patient.xpert_mtb,
          xpert_mtb_date: this.patient.xpert_mtb_date,
          xpert_mtb_code: this.patient.xpert_mtb_code,
          xpert_mtb_h: this.patient.xpert_mtb_h,
          xpert_mtb_am: this.patient.xpert_mtb_am,
          xpert_mtb_cm: this.patient.xpert_mtb_cm,
          xpert_mtb_km: this.patient.xpert_mtb_km,
          xpert_mtb_eth: this.patient.xpert_mtb_eth,
          xpert_mtb_fq: this.patient.xpert_mtb_fq,

          mdrtb_reg_no: this.patient.mdrtb_reg_no,
          mdrtb_regiment: 1,
          mdrtb_reg_year: this.patient.mdrtb_reg_year,
          mdrtb_monopoly: this.patient.mdrtb_monopoly,
          mdrtb_reg_initial: this.patient.mdrtb_reg_initial,

          type_of_patient: this.patient.type_of_patient,
          type_of_tb: this.patient.type_of_tb,
          subtype_patient_other: this.patient.subtype_patient_other,
          subtype_patient_rx: this.patient.subtype_patient_rx,

          treatment_startdate: this.patient.treatment_startdate,
          support_startdate: this.patient.support_startdate,

          comorbid_diseases_other: this.patient.comorbid_diseases_other,

          hiv_status: this.patient.hiv_status,
          hiv_date: this.patient.hiv_date,
          hiv_result: this.patient.hiv_result,

          art_rx: this.patient.art_rx,
          art_rx_date: this.patient.art_rx_date,

          cpt_rx: this.patient.cpt_rx,
          cpt_rx_date: this.patient.cpt_rx_date,

          culture_date: this.patient.culture_date,
          culture_result: this.patient.culture_result,
          culture_code: this.patient.culture_code,

          cxr_result: this.patient.cxr_result,
          cxr_date: this.patient.cxr_date,
          t_in: this.patient.t_in,
          t_in_type: this.patient.t_in_type,
          t_in_date: this.patient.t_in_date,
          t_in_township_id: this.patient.t_in_township_id,
          t_in_township_name: this.patient.t_in_township_name,
          tb_hive_info: 1,
          support_remark: this.patient.support_remark,
        };

        if (this.patient.comorbid_diseases.length > 0) {
          data.comorbid_diseases = this.patient.comorbid_diseases;
        } else {
          data.comorbid_diseases[0] = 1;
        }
        this.$store.dispatch("Enroll/updateEnrollInfo", data);
      } else {
        //if validation has errors  display with toast
        //then clear the errors+
        this.toastErrors.forEach((element) => {
          this.$toast.error(element);
        });
        this.clearToastErrors();
      }
    },
  },
  created() {
    this.getTownships();
    this.getAllTownships();
    this.getOutsideTownships(this.$route.params.township_id);
  },
};
</script>

<style scoped>
.v-card {
  margin: 20px 0px !important;
}
.border-red {
  border-color: red !important;
}
</style>
